import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { FileTranslationKeys } from 'intl/keys';
import {
  ImageConvertStatusNegative,
  ImageConvertStatus,
} from 'shared/domain/imageConvertStatus/imageConvertStatus';

export function getConvertInfo(
  status: ImageConvertStatusNegative | undefined | null
): string {
  switch (status) {
    case ImageConvertStatus.PENDING:
      return '';
    case ImageConvertStatus.FAILED:
      return FileTranslationKeys.imageConvertInfoFailed;
    case ImageConvertStatus.INCORRECT_PAGES:
      return FileTranslationKeys.imageConvertInfoIncorrectPages;
    case ImageConvertStatus.UNCONVERTABLE_EXTENSION:
    case undefined:
    case null:
      return FileTranslationKeys.imageConvertInfoUnconvertable;
  }
}

export function getStatusTextId(
  status: ImageConvertStatusNegative | undefined | null
): string {
  switch (status) {
    case ImageConvertStatus.PENDING:
      return FileTranslationKeys.imageConvertInfoPending;
    case ImageConvertStatus.FAILED:
    case ImageConvertStatus.INCORRECT_PAGES:
    case ImageConvertStatus.UNCONVERTABLE_EXTENSION:
    case undefined:
    case null:
      return FileTranslationKeys.imageConvertInfoSupportedExtensions;
  }
}

export function getStatusIcon(
  status: ImageConvertStatusNegative | undefined | null
): OverridableComponent<SvgIconTypeMap<{}, 'svg'>> {
  switch (status) {
    case ImageConvertStatus.FAILED:
      return WarningIcon;
    case ImageConvertStatus.PENDING:
    case ImageConvertStatus.INCORRECT_PAGES:
    case ImageConvertStatus.UNCONVERTABLE_EXTENSION:
    case undefined:
    case null:
      return InfoIcon;
  }
}
